export const SNACKBAR_HIDE_TIME = 5000;
